import { HttpResponse } from '@angular/common/http';
import { InjectionToken } from '@angular/core';
import { TypedFormGroup } from 'core';
import { BehaviorSubject, Observable } from 'rxjs';

export interface CarrierEditService {
    postCarrierEdit?(form: TypedFormGroup<any>): Observable<CorrelationId>;
}
export interface RequestService {
    requestState$?: BehaviorSubject<RequestStateWithTraits<any> | RequestStateWithComparison<any>>;
    post(form: TypedFormGroup<any>, saveAsDraft: boolean): Observable<CorrelationId>;
    put(form: TypedFormGroup<any>, saveAsDraft: boolean): Observable<CorrelationId>;
    takeStageToWork?(stageToTake: Backend.TakeStageToWorkModel): Observable<HttpResponse<void>>;
    postCarrierEdit?(form: TypedFormGroup<any>): Observable<CorrelationId>;
    cancelRequest?(correlationId: string, reason: string): Observable<void>;
    agencyWasChanged?(agencyInfo: Backend.AgencyShortInfo | null): void;
    requestWasChanged?(): void;
}

export const REQUEST_SERVICE = new InjectionToken<RequestService>('RequestServiceInjectionToken');
